import { apiClient } from "@/lib/api";
import { createApiRequest } from "@/lib/api/createApiService";
import { TARGET_SETUP_ENDPOINTS } from "./target-setup.endpoints";

const extractFileName = (headers = {}) => {
  const contentDisposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const basicMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  return basicMatch?.[1] || "";
};

export const targetSetupService = {
  getFrameworks: async (params = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.FRAMEWORKS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getMasterDataDisclosures: async (params = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.MASTER_DATA_DISCLOSURES,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getTargetsByDisclosure: async (
    disclosureId,
    year,
    params = {},
    options = {},
  ) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.BY_DISCLOSURE(disclosureId, year),
      method: "GET",
      body: params,
      ...options,
    });
  },

  exportRows: async (payload = {}, options = {}) => {
    const response = await apiClient.post(
      TARGET_SETUP_ENDPOINTS.EXPORT,
      payload,
      {
        responseType: "blob",
        ...options,
      },
    );

    return {
      blob: response?.data,
      fileName: extractFileName(response?.headers || {}),
      contentType: response?.headers?.["content-type"] || "",
      status: response?.status,
    };
  },

  getExportSummary: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.EXPORT_SUMMARY,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  createTarget: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.TARGET_SETUP(),
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateTarget: async (id, payload = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.TARGET_SETUP(id),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  updateMetricFrequency: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.FREQUENCY,
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  deleteTarget: async (id, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.TARGET_SETUP(id),
      method: "DELETE",
      ...options,
    });
  },

  bulkCreateTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: TARGET_SETUP_ENDPOINTS.BULK,
      method: "POST",
      body: payload,
      ...options,
    });
  },
};
